<template>
  <li
    v-if="canViewVerticalNavMenuLink(item) && (item.show !== true)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <template v-if="isImageIcon">
        <img
          :src="item.icon || 'CircleIcon'"
          alt="icon"
          width="20px"
          class="mr-1"
        >
      </template>
      <template v-else>
        <feather-icon :icon="item.icon || 'CircleIcon'" />
      </template>
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
  <li
    v-else-if="canViewVerticalNavMenuLink(item) && (item.show === true) && userType === 'system-user'"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <template v-if="isImageIcon">
        <img
          :src="item.icon || 'CircleIcon'"
          alt="icon"
          width="20px"
          class="mr-1"
        >
      </template>
      <template v-else>
        <feather-icon :icon="item.icon || 'CircleIcon'" />
      </template>
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { computed } from '@vue/composition-api'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()
    const userType = JSON.parse(localStorage.getItem('userData')).data.user_type

    const isImageIcon = computed(() => {
      const { icon } = props.item
      return typeof icon === 'string' && icon.startsWith('data:image/')
    })

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
      userType,
      isImageIcon,
    }
  },

}
</script>
